import {lazy} from 'quickstart/utils'
import type {InnerBlock} from 'quickstart/types'
import type {HeaderBlockConfig} from './meta'

const LazyPublicationHeader = lazy(() =>
  import('./PublicationHeader').then(m => ({default: m.PublicationHeader})),
)

const LazyPostHeader = lazy(() =>
  import('./PostHeader').then(m => ({default: m.PostHeader})),
)

export const HeaderBlock: InnerBlock<HeaderBlockConfig> = ({config}) =>
  config.mode === 'publication' ? (
    <LazyPublicationHeader {...config} />
  ) : (
    <LazyPostHeader {...config.post} />
  )
